module.exports = __webpack_public_path__ + "img/Left Back Barbell.6bdbd917.png";